/*
 * Copyright (c) 2020 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";

/**
 * The Card component
 *
 * @author Thais Watanabe
 */
const Card = (props) => {
  return (
    <div
      className={`${props.className} bg-white rounded-lg shadow p-1 mb-5 print:shadow-none`}
    >
      {props.title != null && (
        <div className="px-4 py-5 sm:px-6 print:p-2">
          <h3 className="text-lg leading-6 font-medium text-gray-900 print:bg-gray-50">
            {props.badge} {props.title}
          </h3>
        </div>
      )}
      <div className="px-4 pb-5 sm:px-6">{props.children}</div>
    </div>
  );
};

export default Card;
